<template>
<!-- 审核商家活动管理 -->
<section class="order">
  <div v-show="isList">
    <el-col :span="24" class="order_toolbar toolbar pad_left">
      <!-- 查询区域 -->
      <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <p style="margin: 0; margin-left: -22px" class="goodslist1">
            <span style="margin-left: 31px; margin-top: 5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt/></span>
          </p>
          <div style="position: absolute; right: -19px; top: -10px" class="sanjiao"/>
        </div>
        <el-collapse-transition>
          <div style="padding: 0 12px" v-show="show3">
            <el-form :inline="true" class="demo-form-inline findform">
              <el-form-item class="selectFormItem" label="活动标题：">
                <el-input v-model="name" placeholder="请输入活动标题关键字" maxlength="30" minlength="5"/>
              </el-form-item>
              <el-form-item class="selectFormItem" label="所属城市：">
                <el-cascader v-model="chengshi" placeholder="请选择城市" :options="options"
                  style="width: 100%" filterable clearable @change="handleChange"/>
              </el-form-item>
              <el-form-item class="selectFormItem" label="状　　态：">
                <el-select v-model="stateId" placeholder="请选择" filterable>
                  <el-option v-for="(item, index) in statearr" :key="index" :value="item.Id" :label="item.Name"/>
                </el-select>
              </el-form-item>
            </el-form>
            <el-form :inline="true" class="demo-form-inline findform">
              <el-form-item label="活动时间：" style="display: flex; width: 73%" class="select">
                <el-date-picker v-model="value6" @change="handleChangeTime" style="width: 100%"
                  type="month" format="yyyy-MM" value-format="yyyy-MM"
                  placeholder="请选择活动年份或月份" @input="immediUpdate"/>
              </el-form-item>
              <el-form-item label="商　　家：" style="display: flex; width: 73%" class="select">
                <el-select v-model="businessId" placeholder="请选择商家" filterable>
                  <el-option v-for="(item, index) in businessArr" :key="index" :value="item.Id" :label="item.Name"/>
                </el-select>
              </el-form-item>

              <el-form-item class="selectFormItem"/>
              <el-form-item class="selectFormItem" style="margin-left: 30px">
                <el-button type="danger" @click="onSubmit()" style="float: right">查 询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
    </el-col>
    <!-- 列表区域 -->
    <template>
      <el-col :span="24" class="order_content main_container">
        <section class="model_section">
          <el-col :span="18" style>
            <p class="model_top_title">审核商家活动列表</p>
          </el-col>
        </section>

        <div class="table_container">
          <div class="table_inner_container">
            <el-table :data="goodList" stripe border style="height: auto">
              <el-table-column label="序号" align="center" width="60px">
                <template scope="scope">{{scope.$index + 1}}</template>
              </el-table-column>
              <el-table-column prop="CityName" label="所在城市" align="center">
                <template scope="scope">
                  <span>{{ scope.row.CityName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="BusinessName" align="center" label="发起品牌商" width="260">
                <template scope="scope">
                  <span>{{ scope.row.BusinessName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="Title" label="活动标题" align="center">
                <template scope="scope">
                  <span>{{ scope.row.Title }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="EffectiveDate" label="活动时间" align="center">
                <template scope="scope">
                  <span>{{ scope.row.EffectiveDate }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="StateName" label="状态" align="center">
                <template scope="scope">
                  <span>{{ scope.row.StateName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" align="center">
                <template scope="scope">
                  <span class="handle" @click="seeinfo(scope.row, 3)">
                    <i class="el-icon-view"></i> 查看
                  </span>
                  <span class="handle" @click="endToExamine(scope.row)" v-if="scope.row.State == 2">
                    <i class="el-icon-s-check"></i> 审核
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="table_inner_container" style="margin-bottom: 10px">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
              :page-size="10" :current-page="pageIndex" :total="total" style="float: right; margin-top: 10px"/>
          </div>
        </div>
      </el-col>
    </template>
  </div>

  <!-- 新增/编辑弹框 :fullscreen="true" :modal="false"-->
  <section custom-class="activityDiaStyle" v-if="addActiveDia">
    <el-col :span="24" class="add_order_watch main_container pad_left">
      <section class="model_section" style="margin-bottom: 0">
        <el-col :span="14">
          <p class="model_top_title" style="font-weight: 500">
            {{ addActiveTitle }}
          </p>
        </el-col>
        <el-col :span="10">
          <p @click="hideAddActiveDia()" class="add_new_btn">关闭</p>
        </el-col>
      </section>
      <div>
        <el-steps v-if="showStep&&!activityTypeFrom"
          :active="addActive>=2?addActive-1:addActive" finish-status="success" simple>
          <el-step title="基本信息"></el-step>
          <!-- <el-step title="参展品牌"></el-step> -->
          <el-step title="活动形式"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
        <!-- 1-4步 -->
        <oneStep ref="oneStep" v-if="addActive == 0&&!activityTypeFrom"
          @cancleAddBaseMsg="cancleAddBaseMsg" @toNextStep="toNextStep" :whichRole="false"/>

        <exhibitionBrandList ref="exhibitionBrandList" v-if="addActive == 1&&!activityTypeFrom"
          @toPrevStep="toPrevStep" @toNextStep="toNextStep"/>

        <activityFormList ref="activityFormList" v-if="addActive == 2&&!activityTypeFrom"
          @toPrevStep="toPrevStep" @toNextStep="toNextStep"
          @showWhichAddActiveForm="showWhichAddActiveForm" :whichRole="false"/>

        <activityDescription ref="activityDescription" v-if="addActive == 3&&!activityTypeFrom"
          @toPrevStep="toPrevStep" @saveAllForm="saveAllForm"/>
            
        <!-- 第三步中的新增活动表单 -->
        <addActiviteForm ref="addActiviteForm" v-if="addActive == 2 && activityTypeFrom"
          :activityTypeFrom="activityTypeFrom" @cancelActiveForm="cancelActiveForm" @newAdd="newlyAdded"/>
      </div>
    </el-col>
  </section>

  <!-- 商家审核-弹框 -->
  <el-dialog class="add_order_cancle" width="30%" title="商家审核" :center="true" :visible.sync="isToExamine">
    <!-- <el-form>
      <el-form-item>
        <el-input type="textarea" placeholder="请输入审核备注" maxlength="200" v-model="shenmark" :rows="3"/>
      </el-form-item>
    </el-form> -->
    <div class="toExamineTitle">
      <i class="el-icon-warning-outline"></i>
      <p>请确认是否执行 通过 & 驳回 !</p>
    </div>
    <div style="padding-left:0;text-align:center">
      <el-button type="danger" @click="rejectToExamine()">驳 回</el-button>
      <el-button type="danger" @click="adoptToExamine()">通 过</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import { getAllProvinceAndCityList, getBusinessExamineActivityList, getExamineStatus, getExamineBusiness,
  getExamineSuccess, getExamineFail } from "../../api/activityFormList";
import oneStep from "../../components/addOrEditActive/oneStep";
import addActiviteForm from "../../components/addOrEditActive/addActiviteForm";
import exhibitionBrandList from "../../components/addOrEditActive/exhibitionBrandList";
import activityFormList from "../../components/addOrEditActive/activityFormList";
import activityDescription from "../../components/addOrEditActive/activityDescription";
export default {
  name: 'AuditBusinessList', // 审核商家活动
  data() {
    return {
      toExamineId: "", // 活动id
      activeListData:[],
      refsList: [
        { name: "oneStep" }, //基本信息组件
        { name: "exhibitionBrandList" }, //参展品牌组件
        { name: "activityFormList" }, //活动形式组件
        { name: "activityDescription" }, //活动说明组件
        { name: "addActiviteForm" }, //活动形式中的表单组件
      ],
      // 特价商品表单
      addActiveTitle: "新增/编辑活动",
      showStep: true,
      activityTypeFrom: 0,
      // 控制活动时间不能小于当前时间
      pickerOptionsStart: {
        disabledDate(time) {
          return (
            time.getTime() < new Date(new Date().toLocaleDateString()).getTime()
          );
        },
      },
      addActive: 0, //默认的活动编辑的步骤进度

      isList: true, //新增活动弹框
      addActiveDia: false, //新增活动弹框
      addInnerVisible: false, //新增活动弹框

      rooid: "", // rooid
      isEditOrAddOrSee: 0,

      goodList: [],
      name: "", // 活动标题
      provinceId: 0, // 省id
      cityId: 0, // 市id
      stateId: 0, // 状态
      value6: "", // 活动时间
      sTime: "", // 年
      eTime: "", // 月
      businessId: 0, // 商家
      pageIndex: 1, // 页码
      total: 0,
      
      statearr: [], // 状态
      businessArr: [], // 商家
      message: "113",
      show3: false,
      chengshi: "",
      tbdprovince: [],
      tbdcity: [],
      options: [
        {
          value: 0,
          label: "全部",
        },
      ],
      oneStepformData:'',
      editActivityId: "", // 活动id
      isToExamine: false, // 商家审核弹框
      shenmark: "", // 审核意见
    };
  },
  components: {
    oneStep, //基本信息
    exhibitionBrandList, //参展商品
    activityFormList, //活动形式
    addActiviteForm, //添加的活动表单（特价 团购 优惠券 签到礼）  优惠券
    activityDescription, // 活动说明（第四步）
  },
  methods: {
    // 关闭
    hideAddActiveDia() {
      this.addActiveDia = false;
      this.isList = true;
      this.init();
    },
    // 取消添加活动
    cancleAddBaseMsg() {
      this.addActiveDia = false;
      this.isList = true;
    },
    // 上一步
    toPrevStep(whichStep,isEdit) {
      // if(whichStep=='toOne'){  //第一步 返回到基本信息
      //   this.addActiveTitle = "新增/编辑活动";
      // this.showStep = true;

      // }else if(whichStep=='toTwo'){  //第二步 返回到参展品牌
      //   this.addActiveTitle = "新增/编辑活动";
      // this.showStep = true;
      // this.addActive = 1;
      // }else if(whichStep=='toThree'){  //第二步 返回到参展品牌
      // this.addActiveTitle = "新增/编辑活动";
      // this.showStep = true;
      // this.addActive = 2;
      // }
      this.addActive = whichStep;
      this.addActiveTitle = "新增/编辑活动";
      this.showStep = true;
      this.$nextTick(() => {
        // if (this.addActive == 0) {
          this.$refs[this.refsList[whichStep].name].initComponent(this.editActivityId,isEdit?1:this.isEditOrAddOrSee,this.activeListData,);
        // } 
        // else {
      //     // this.$refs[this.refsList[whichStep].name].initComponent();
      //   }
      });
    },
    // 上一步===> 由新增活动表单返回到活动形式
    cancelActiveForm(whichStep) {
      this.addActive = whichStep;
      this.addActiveTitle = "新增/编辑活动";
      this.showStep = true;
      this.activityTypeFrom = 0;
      this.$set(this,"activityTypeFrom",0);
      this.$nextTick(() => {
        this.$refs[this.refsList[whichStep].name].initComponent(this.editActivityId,this.isEditOrAddOrSee,this.activeListData,this.threeFromType);
      });
      
    },
    // 下一步
    toNextStep(whichStep, formData,activeListData) {
      this.addActive = whichStep;
      this.addActiveTitle = "新增/编辑活动";
      this.showStep = true;
       if(this.addActive==0){
        // this.oneStepformData = formData;
      }else if(this.addActive==1){
        this.editActivityId = formData;
        this.activeListData = activeListData;
      }else if(this.addActive==2){
        this.editActivityId = formData;
        this.activeListData = activeListData;
      }else if(this.addActive==3){
        this.oneStepformData = formData;
      }
      // this.oneStepformData = formData;
      this.$nextTick(() => {
        this.$refs[this.refsList[whichStep].name].initComponent(this.editActivityId,this.isEditOrAddOrSee,this.activeListData);
      });
    },
    // 展示第三步中的新增活动表单
    showWhichAddActiveForm(editActivityId,activityTypeFrom,soId, type) {
      // this.addActiveDia=false;
      this.threeFromType=activityTypeFrom;
      this.activityTypeFrom = activityTypeFrom; //新增的活动形式类型（1 特价 2 秒杀  3 团购 4 优惠券  5 签到礼）
      this.$set(this,"activityTypeFrom",activityTypeFrom);
       this.$nextTick(() => {
        this.$refs.addActiviteForm.initComponent(this.editActivityId, this.activityTypeFrom,soId,type);
      });
    },
    // 接收第三部详情页数据
    newlyAdded(itemForm) {
      this.activityTypeFrom = 0;
      this.addActiveDia = true;
      this.addActive = 2;
       this.$nextTick(() => {
        this.$refs[this.refsList[this.addActive].name].initComponent(this.editActivityId,this.isEditOrAddOrSee,this.activeListData,this.threeFromType);
      });
    },
    // 保存添加的所有活动表单数据
    saveAllForm(content) {
      this.addActiveDia = false;
      this.isList = true;
      this.init();
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    //获取活动列表
    init() {
      var obj = {
        UserId: localStorage.Id, // 用户id
        Title: this.name, // 活动标题
        ProvinceId: this.provinceId, // 省id
        CityId: this.cityId, // 市id
        State: this.stateId, // 状态
        Year: this.sTime, // 年
        Month: this.eTime, // 月
        BusinessId: this.businessId, // 商家
        PageIndex: this.pageIndex, // 页码
        PageSize: 10,
      };
      getBusinessExamineActivityList(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.goodList = data.ResultObj;
          this.total = data.RowsCount;
        } else {
          this.goodList = [];
          this.total = 0;
        }
      });
    },
    // 重置
    fnReset() {
      this.name = "";
      this.chengshi = "";
      this.provinceId = 0;
      this.cityId = 0;
      this.stateId = 0; // 状态
      this.value6 = "";
      this.sTime = 0;
      this.eTime = 0;
      this.businessId = 0; // 商家
      this.pageIndex = 1;
      this.init();
    },
    // 查询活动列表分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    //时间选择器修改
    handleChangeTime(val) {
      let newVal = val.split("-");
      if (newVal == null) {
        this.sTime = "";
        this.eTime = "";
        return false;
      }
      this.sTime = newVal[0];
      this.eTime = newVal[1];
    },
    // 活动时间控件 做清空处理
    immediUpdate(e) {
      this.$nextTick(() => {
        if(e==null){
          this.sTime='';
          this.eTime='';
        }
      });
    },
    //查看
    seeinfo(row, type) {
      this.addActiveDia = true;
      this.isList = false;
      this.isEditOrAddOrSee = 3;
      this.addActive = 0;
      this.activityTypeFrom = 0;
      this.$nextTick(() => {
        this.$refs[this.refsList[0].name].initComponent(row.Id, this.isEditOrAddOrSee);
      })
    },
    // 审核
    endToExamine(row) {
      this.toExamineId = row.Id;
      this.isToExamine = true; // 审核弹框展示
    },
    // 审核通过
    adoptToExamine() {
      // if (this.shenmark == "") {
      //  this.$swal({
      //     type:"warning",
      //     text:"请输入审核意见"
      //   })
      //   return false;
      // }
      let addParams = {
        activityId: this.toExamineId, // 活动id
      };
      getExamineSuccess(addParams).then(data => {
          this.$swal({
            text: "审核成功",
            type: "success"
          });
          this.isToExamine = false;
          this.init()
        })
    },
    // 驳回
    rejectToExamine() {
      // if (this.shenmark == "") {
      //  this.$swal({
      //     type:"warning",
      //     text:"请输入驳回原因"
      //   })
      //   return false;
      // }
      let addParams = {
        activityId: this.toExamineId, // 活动id
      };
      getExamineFail(addParams).then(data => {
          this.$swal({
            text: "驳回成功",
            type: "success"
          });
          this.isToExamine = false;
          this.init()
        })
    },
    // 状态
    getStatearr() {
      var obj = {};
      getExamineStatus(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.statearr = data.ResultObj;
          this.statearr.unshift({
            Id: 0,
            Name: "全部",
          });
        }
      });
    },
    // 商家
    getBusinessArr() {
      var obj = {
        userId: localStorage.Id
      };
      getExamineBusiness(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.businessArr = data.ResultObj;
          this.businessArr.unshift({
            Id: 0,
            Name: "全部",
          });
        } else {
          this.businessId = "";
          this.businessArr = [];
        }
      });
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    //查找省
    getprovince() {
      var loginParams = {
        isOpen: 1,
        userId: localStorage.Id
      };
      getAllProvinceAndCityList(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.ResultObj.map(item => {
          // 省
          let provinceData = {value:item.Id,label:item.Name,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.CityList.map(city => {
            let cityData = {value:city.Id, label:city.Name};
            provinceData.children.push(cityData);
          })
        });
        that.options = provinceAndCityAndarea;
      })
    },
  },
  mounted() {
    this.getprovince(); // 省市
    this.getStatearr(); // 状态
    this.getBusinessArr(); // 商家
    this.init(); // 查询列表
  },
};
</script>
<style scoped>
.selectFormItem {
  width: 33.33%;
  display: flex;
}
</style>


// WEBPACK FOOTER //
// AuditBusinessList.vue?752109c2